module.exports = __webpack_public_path__ + "img/xy_xdyz.7a5ee481.png";